import GROW_2529_EXPERIMENT_DETAILS_COPY from '~app/pages/Pricing/experiments/grow_2529_forms/copy/experimentDetailsCopy';
import GROW_2792_EXPERIMENT_DETAILS_COPY from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentDetailsCopy';

const EXPERIMENT_DETAILS_COPY = {
  ...GROW_2529_EXPERIMENT_DETAILS_COPY,
  ...GROW_2792_EXPERIMENT_DETAILS_COPY,
};

export default EXPERIMENT_DETAILS_COPY;
